if not App.angularApp?
    return

App.angularApp.directive 'mfValidateModel', ['$timeout', ($timeout) ->
    restrict: 'A'
    # require: '^mfValidate'
    link: ($scope, element, attrs, mfValidate) ->
        $timeout () ->
            mfValidateElement = element.closest '[mf-validate]'
            mfValidateElement.scope().$validationController.registerInput element
]
